import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { parse } from 'qs'
import { useIntl } from 'react-intl'
import { withStyles } from '@mui/styles'
import { Box, Container, Typography } from '@mui/material'


import { setUsers } from '../../slices'
import { GuildUsersTable } from '../table'
import { GuildUsersFilter } from '../filter'
import { guildUsersDashboardStyles } from './guild-users-dashboard.styles'
import { USERS_DEFAULT_QUERY } from '../../constants'

export const GuildUsersDashboard = withStyles(guildUsersDashboardStyles)(({ classes }) => {
  const { formatMessage } = useIntl()
  const dispatch = useDispatch()
  const guildId = useSelector((state) => state.global.gremio_id)
  //Acquire url and parse its search options
  const url = useLocation().search
  const urlSearchParams = parse(url.split('?')[1])
  const searchParams = {
    ...USERS_DEFAULT_QUERY,
    ...urlSearchParams,
  }

  useEffect(() => {
    dispatch(setUsers(searchParams, guildId))
  }, [url]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Box>
      <Container className={classes.container} maxWidth="lg">
        <Box mb={2}>
          <Typography variant="h4" color="textSecondary">
            {formatMessage({ id: 'pages.users.title' })}
          </Typography>
        </Box>
        <Box mb={2}>{<GuildUsersFilter searchParams={searchParams} />}</Box>
        <Box>
          <GuildUsersTable />
        </Box>
      </Container>
    </Box>
  )
})
